import styled, { css as styledCSS } from "styled-components";

export const Table = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
`;

export const TableRow = styled.tr<{ $isActive?: boolean }>`
  height: 24px;
  font-size: 13px;
  line-height: 18px;
  color: var(--section-night-color, var(--night));
  background-color: transparent;
  > :first-child {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  > :last-child {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }

  td.date,
  td.percentage {
    width: 1%;
    padding-left: 8px;
  }

  td.date {
    color: var(--theme-neutral-400);
  }

  td.percentage {
    font-weight: 400;
    color: var(--mode-text-neutral-weakest);
  }

  td.value {
    width: 1%;
    padding-left: 8px;
    padding-right: 8px;
  }

  td.host-name {
    text-align: left;
    white-space: nowrap;
    padding-right: 8px;
  }

  ${({ $isActive }) =>
    $isActive &&
    styledCSS`
      background-color: var(--menu-item-color-primary-100-background-color,var(--color-primary-100));
    `};
`;

export const ContentWrapper = styled.div`
  width: 260px;
`;
